<!--
    Panel wyboru poszczególnej konfiguracji/tekstury
    Przyciski złożone z TexturButton
-->

<i18n>
    {
    "en": {
    "back": "BACK TO THE PATTERN SELECTION",
    "slogan": "Infinite movement",
    "slogan_crystal": "Infinite movement",
    "slogan_tweed": "Textile inspiration",
    "slogan_verde": "Vegetal spirit",
    "select": "SELECT YOUR CONFIGURATION",
    "ceiling":"Ceiling",
    "ceiling_primary":"Ceiling (primary)",
    "ceiling_secondary":"Ceiling (secondary)",
    "wall":"Wall",
    "change_view": "Change View",
    "view_front": "View 1",
    "view_back": "View 2"
    },

    "fr": {
    "back": "Revenir à la sélection",
    "slogan": "Mouvement infini",
    "slogan_crystal": "Mouvement infini",
    "slogan_tweed": "Inspiration textile",
    "slogan_verde": "Esprit végétal",
    "select": "Sélectionnez la configuration",
    "ceiling":"Plafond",
    "ceiling_primary":"Plafond (principal)",
    "ceiling_secondary":"Plafond (secondaire)",
    "wall":"Mur",
    "change_view": "Changez de vue",
    "view_front": "Vue 1",
    "view_back": "Vue 2"
    },

    "pl": {
    "back": "Wróć do wyboru rodzaju wzoru",
    "slogan": "Nieskończony ruch",
    "slogan_crystal": "Nieskończony ruch",
    "slogan_tweed": "Inspiracje tekstylne",
    "slogan_verde": "Inspiracja roślinna",
    "select": "WYBIERZ KONFIGURACJĘ",
    "ceiling":"Sufit",
    "ceiling_primary":"Sufit (główny)",
    "ceiling_secondary":"Sufit (pozostały)",
    "wall":"Ściany",
    "change_view": "Zmień widok",
    "view_front": "Widok 1",
    "view_back": "Widok 2"
    },

    "de": {
    "back": "Zurück zur Auswahl der Lochmuster",
    "slogan": "infinite movement",
    "slogan_crystal": "Infinite movement",
    "slogan_tweed": "Textile inspiration",
    "slogan_verde": "Vegetal spirit",
    "select": "Wählen Sie das Konfiguration",
    "ceiling":"Decke",
    "ceiling_primary":"Decke (primär)",
    "ceiling_secondary":"Decke (sekundär)",
    "wall":"Wand",
    "change_view": "Ändern Sie die Ansicht",
    "view_front": "Ansicht 1",
    "view_back": "Ansicht 2"
    }

    }
</i18n>

<template>
    <div class="TexturesPanel" v-bind:class="[serie, { show_mobile: showMobileMenu  }]">
        <button class="back" @click="changeSceneClick('select')">
            &lt; {{ $t('back') }}
        </button>

        <div class="container">
            <h1>{{ serie }}</h1>
            <p class="slogan">
                {{ $t('slogan_' + serie) }}
            </p>

            <div class="content">
                <h2 class="select">
                    {{ $t('select') }}
                </h2>

                <div class="textures_group" v-if="isSerie('crystal')">
                    <h3>{{ $t('ceiling') }}</h3>
                    <div class="textures_row">
                        <TextureButton :scene="scene" :texture="'crystal_8'" class="crystal" :surfaceId="1" />
                        <TextureButton :scene="scene" :texture="'crystal_14'" class="crystal" :surfaceId="1" />
                        <TextureButton :scene="scene" :texture="'crystal_23'" class="crystal" :surfaceId="1" />
                    </div>
                </div>

                <div class="textures_group" v-if="isSerie('tweed')">
                    <h3>{{ $t('ceiling') }}</h3>
                    <div class="textures_row">
                        <TextureButton :scene="scene" :texture="'tweed_10'" class="tweed" :surfaceId="1" />
                        <TextureButton :scene="scene" :texture="'tweed_14'" class="tweed" :surfaceId="1" />
                        <TextureButton :scene="scene" :texture="'tweed_20'" class="tweed" :surfaceId="1" />
                    </div>
                    <h3>{{ $t('wall') }}</h3>
                    <div class="textures_row">
                        <TextureButton :scene="scene" :texture="'tweed_10'" class="tweed" :surfaceId="2" />
                        <TextureButton :scene="scene" :texture="'tweed_14'" class="tweed" :surfaceId="2" />
                        <TextureButton :scene="scene" :texture="'tweed_20'" class="tweed" :surfaceId="2" />
                    </div>
                </div>

                <div class="textures_group" v-if="isSerie('verde')">
                    <h3>{{ $t('ceiling_primary') }}</h3>
                    <div class="textures_row">
                        <TextureButton :scene="scene" :texture="'verde_8'" class="verde" :surfaceId="1" />
                        <TextureButton :scene="scene" :texture="'verde_11'" class="verde" :surfaceId="1" />
                        <TextureButton :scene="scene" :texture="'verde_17'" class="verde" :surfaceId="1" />
                    </div>
                    <h3>{{ $t('ceiling_secondary') }}</h3>
                    <div class="textures_row">
                        <TextureButton :scene="scene" :texture="'verde_8'" class="verde" :surfaceId="2" />
                        <TextureButton :scene="scene" :texture="'verde_11'" class="verde" :surfaceId="2" />
                        <TextureButton :scene="scene" :texture="'verde_17'" class="verde" :surfaceId="2" />
                    </div>
                </div>

                <!--<span class="spacer" v-if="isSerie('crystal')"></span>-->
                <!--<span class="spacer" v-if="isSerie('tweed')"></span>-->

            </div>

            <div class="view_container">
                <h3>{{ $t('change_view') }}</h3>

                <div class="view_buttons">
                    <button :class="{ active: viewAB == 'a' }" @click="changeSceneClick(viewBase + 'a')">
                        {{ $t('view_front') }}
                    </button>

                    <button :class="{ active: viewAB == 'b' }" @click="changeSceneClick(viewBase + 'b')">
                        {{ $t('view_back') }}
                    </button>
                </div>

                <br />
            </div>

            <br />
        </div>

        <button class="texture_panel_toggle" @click="showMobileMenu = !showMobileMenu">
            ⇔
        </button>
    </div>
</template>

<script>
    import TextureButton from './TextureButton.vue';

    export default {
        name: 'TexturesPanel',

        props: {
            scene: String,
        },
        data() {
            return {
                showMobileMenu: false
            }
        },
        components: {
            TextureButton,
        },
        computed: {
            serie: function () {
                return (this.scene.split("_")[0])
            },
            viewAB: function () {
                return this.scene.slice(-1)
            },
            viewBase: function () {
                return this.scene.slice(0, -1)
            }
        },
        methods: {
            isSerie: function (val) {
                return (this.scene.split("_")[0] == val)
            },
            changeSceneClick: function (val) {
                this.$root.$emit('changeSceneClick', val)
            },
            mobileToggle: function () {

            }
        }
    };
</script>

<style scoped>

    .TexturesPanel {
        /*margin-top: 5px;*/
        display: inline-block;
        width: 340px;
        height: 100%;
        vertical-align: top;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        background: #434D56;
        color: #FFF;
        transition: all 300ms ease;
    }

        .TexturesPanel.crystal {
            background: #76A1B1;
        }

        .TexturesPanel.tweed {
            background: #8D8F92;
        }

        .TexturesPanel.verde {
            background: #9CB493;
        }

        .TexturesPanel .container {
            overflow: auto;
            height: calc(100% - 60px);
        }

        .TexturesPanel .back {
            display: block;
            height: 60px;
            width: 100%;
            background: #434D56;
            border: 0;
            border-bottom: 0px solid #FFF;
            cursor: pointer;
            color: #FFF;
            font-size: 0.9rem;
            text-transform: uppercase;
        }

        .TexturesPanel h1 {
            text-align: center;
            text-transform: uppercase;
            font-weight: normal;
            margin-bottom: 0;
            font-size: 40px;
        }

        .TexturesPanel .slogan {
            text-align: center;
            text-decoration: underline;
            margin-top: 0;
            font-size: 21px;
            text-transform: lowercase;
        }

        .TexturesPanel .content {
            margin: 0 20px;
        }

            .TexturesPanel .content h2.select {
                font-weight: normal;
                color: #434D56;
                font-size: 1rem;
                text-align: center;
                margin: 40px 0 0 0;
                text-transform: uppercase;
            }

            .TexturesPanel .content h3 {
                font-weight: normal;
                font-size: 18px;
                text-transform: uppercase;
            }


    .view_container {
        margin: 0 20px 50px;
        text-transform: uppercase;
    }

        .view_container h3 {
            font-weight: normal;
            font-size: 18px;
        }

    .view_buttons {
        display: flex;
        justify-content: space-between;
    }

        .view_buttons button {
            background: #FFF;
            width: 130px;
            height: 40px;
            text-transform: uppercase;
            cursor: pointer;
            border: 0;
            border-radius: 8px;
            outline: none;
            opacity: 1;
            color: #FFF;
        }

            .view_buttons button:hover {
                opacity: 0.8;
            }

            .view_buttons button.active {
                background: #434D56;
            }

                .view_buttons button.active:hover {
                    opacity: 1;
                }


    .crystal .view_buttons button.active {
        color: #FFF;
    }

    .tweed .view_buttons button.active {
        color: #FFF;
    }

    .verde .view_buttons button.active {
        color: #FFF;
    }

    .crystal .view_buttons button {
        color: #76A1B1;
    }

    .tweed .view_buttons button {
        color: #8D8F92;
    }

    .verde .view_buttons button {
        color: #9CB493;
    }



    span.spacer {
        display: inline-block;
        margin: 5px;
        padding: 5px;
    }

    .textures_row {
        display: flex;
        justify-content: space-around;
        align-items: flex-start;
        height: 100px;
    }

    .TextureButton.crystal {
        /* KOLORY */
    }

    .TextureButton.tweed {
        /* KOLORY */
    }

    .TextureButton.verde {
        /* KOLORY */
    }

    .texture_panel_toggle {
        display: none;
        width: 40px;
        height: 25%;
        position: absolute;
        top: 35%;
        right: -40px;
        border: 0;
        outline: 0;
        color: #FFF;
        background-color: rgba(67, 77, 86, 0.6)
        /*background: radial-gradient(circle, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%);*/
    }


    @media only screen and (max-device-width : 1024px) {
        .TexturesPanel {
            width: 320px;
            left: -320px;
        }

            .TexturesPanel.show_mobile {
                left: 0;
            }

        .texture_panel_toggle {
            display: block;
        }
    }
</style>
